import React from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Termsbanner from "../Pages/Terms/Terms";
import Termscenter from "../Pages/Terms/Termscenter";
import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Termstheme() {
  return (
    <>
      <Header />
      <Termsbanner />
      <Termscenter />
      <Footer />
    </>
  );
}
